module.exports = __webpack_public_path__ + "img/1-1.abb85d6e.png";